import React, { useState } from "react";
import "../../TeamManager/styles/teamManagerStyles.css";
import SettingsPageWrapper from "../../../shared/SettingsPageWrapper";
import { updateTeamSetting } from "../../../shared/api/team";

const BASE_CURRENCY_OPTIONS = [
  { value: 'USD', label: 'United States Dollar (USD)' },
  { value: 'CAD', label: 'Canadian Dollar (CAD)' },
];

const SECONDARY_CURRENCY_OPTIONS = [
  { value: '', label: 'Select a secondary currency...' },
  { value: 'EUR', label: 'Euro (EUR)' },
  { value: 'JPY', label: 'Japanese Yen (JPY)' },
  { value: 'GBP', label: 'Pound Sterling (GBP)' },
  { value: 'AUD', label: 'Australian Dollar (AUD)' },
  { value: 'CAD', label: 'Canadian Dollar (CAD)' },
  { value: 'CHF', label: 'Swiss Franc (CHF)' },
  { value: 'CNY', label: 'Chinese Renminbi (CNY)' },
  { value: 'USD', label: 'United States Dollar (USD)' },
];

const SettingsCurrencyDetails = ({ team, settingsPath, lastEditedAt, changelogVersions }) => {
  const [baseCurrency, setBaseCurrency] = useState(team.base_currency_symbol || 'USD');
  const [secondaryCurrency, setSecondaryCurrency] = useState(team.secondary_currency_symbol || '');

  const handleBaseCurrencyChange = (e) => {
    const value = e.target.value;
    setBaseCurrency(value);
    updateTeamSetting(team.id, { base_currency_symbol: value });
  };

  const handleSecondaryCurrencyChange = (e) => {
    const value = e.target.value;
    setSecondaryCurrency(value);
    const params = { secondary_currency_symbol: value };
    if (!value) {
      params.secondary_currency_rate = '';
      params.use_latest_exchange_rates = true;
    }
    updateTeamSetting(team.id, params);
  };

  return (
    <SettingsPageWrapper settingsPath={settingsPath} title="Currency" lastEditedAt={lastEditedAt} changelogVersions={changelogVersions}>
      <div className="team-member-card">
        <div className="team-member-card-header">
          <div className="team-member-card-header-left">
            <div className="team-member-card-title-row">
              <h2 className="team-member-card-title">Currency</h2>
            </div>
            <p className="team-member-card-subtitle">
              Customize your primary and secondary currency.
            </p>
          </div>
        </div>
        <hr style={{ margin: 0, border: 'none', borderTop: '1px solid var(--sl-border-secondary)' }} />

        <div style={{ padding: '32px 24px' }}>
          <div>
            <p className="mb-1 text-dark" style={{ fontSize: 16 }}>
              <strong>Base Currency</strong>
            </p>
            <p className="m-0 small text-muted">
              Select the default currency that will be used in offers and settlements.
            </p>
          </div>
          <div className="mt-3">
            <select
              className="team-form-select"
              style={{ width: 280, maxWidth: '100%' }}
              value={baseCurrency}
              onChange={handleBaseCurrencyChange}
            >
              {BASE_CURRENCY_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>

          <hr className="my-4" style={{ borderTop: '1px solid var(--sl-border-secondary)' }} />

          <div>
            <p className="mb-1 text-dark" style={{ fontSize: 16 }}>
              <strong>Secondary Currency</strong>
            </p>
            <p className="m-0 small text-muted">
              Select a secondary currency that will be included in Offers and Settlement.
            </p>
          </div>
          <div className="mt-3">
            <select
              className="team-form-select"
              style={{ width: 280, maxWidth: '100%' }}
              value={secondaryCurrency}
              onChange={handleSecondaryCurrencyChange}
            >
              {SECONDARY_CURRENCY_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </SettingsPageWrapper>
  );
};

export default SettingsCurrencyDetails;
